export default __webpack_public_path__ + "static/media/TopContainer.315228be.png";